<template lang="pug">
  .tree-wrapper
    .tree-categories
      .parent-package-wrapper.parent-package-subwrapper(
        @click="selectQty(item)"
        v-for="item in items"
        :key="item.pk"
      )
        .tree-category.tree-family.tree-subfamily
          span {{item.name}}
    .qty-bg(v-if="qtyVisible")
    .qty-wrapper(v-if="qtyVisible")
      .qty-box(v-if="maxQty")
        h3 Seleccione la cantidad de preguntas
        ul
          li(@click="createTest(25)" v-if="maxQty >= 25")
            span 25
          li(@click="createTest(50)" v-if="maxQty >= 50")
            span 50
          li(@click="createTest(75)" v-if="maxQty >= 75")
            span 75
          li(@click="createTest(maxQty)" v-if="maxQty < 75")
            span Todas

</template>

<script type="text/javascript">
import _ from "underscore";
import api from "@/service/api";
import { mapState } from "vuex";

export default {
  name: "Family",
  props: ["family"],
  computed: mapState([
    "token",
    "username"
  ]),
  data() {
    return {
      items: [],
      qtyVisible: false,
      selectedItem: null,
      maxQty: null,
      me: null,
      subfamily: null,
    };
  },
  async created() {
    const self = this;

    const responseMe = await api.me(this.token)
    this.me = responseMe.data

    const responseTree = await api.tree(this.token)
    const data = responseTree.data.tree
    const family = _.findWhere(data, { pk: parseInt(self.family) });
    self.items = family.children;
  },
  methods: {
    selectQty(item) {
      const self = this;
      this.subfamily = item.pk;

      api
        .infoTest(this.token, item.pk)
        .then((response) => {
          let total = response.data.total;
          self.maxQty = total;
          self.selectedItem = item;
          self.qtyVisible = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createTest(qty) {
      const self = this;
      this.qtyVisible = false;

      let pk = this.selectedItem.pk;
      console.log({ qty });

      api
        .newTest(this.token, pk, qty)
        .then((response) => {
          const data = response.data;
          const uuid = data.public_key;
          self.$router.push({
            name: "Test",
            params: {
              uuid,
              subfamilyParam: self.subfamily,
            },
          });
        })
        .catch();
    },
  },
};
</script>
